// extracted by mini-css-extract-plugin
export default {"wrapper":"Whoops_wrapper__WuMIC","status":"Whoops_status__a2pJE","message":"Whoops_message__FEAvv"};